import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    data: [],
    links: {},
    loadingStatus: 'idle',
    error: null
}

export const fetchReports = createAsyncThunk(
    'reports/fetchReports',
    async ({token, params}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            };

            const response = await request(
                `${APP_URL}api/reports?${params}`,
                'GET',
                null,
                customHeaders
            );
            return {
                data: response.data,
                links: response.links
            }
        } catch (error) {
            return rejectWithValue(error.status)
        }
    }
);

const reportSlice = createSlice({
    name: 'reports',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchReports.pending, (state) => {
                state.loadingStatus = 'loading';
            })
            .addCase(fetchReports.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.links = action.payload.links;
                state.loadingStatus = 'idle';
            })
            .addCase(fetchReports.rejected, (state, action) => {
                state.loadingStatus = 'error';
                state.error = action.payload;
            })
    }
});

export default reportSlice.reducer;

